module.exports = __webpack_public_path__ + "9f977132bb22ce4ece4616626ed0e806.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/miller_howard_funds_trust.png
// module id = 1701
// module chunks = 0